<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-card class="rounded-lg" elevation="1">
          <v-card-title color="#f8f9fb" elevation="0">
            <v-row align="center" no-gutters>
              <v-col cols="auto">
                <span class="text-h6 font-weight-regular">{{
                  $t("staff.title")
                }}</span>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="12" sm="4" md="3" class="px-3">
                <v-text-field
                  v-model="search"
                  label="Search"
                  append-icon="mdi-magnify"
                  single-line
                  hide-details
                  clearable
                  @input="
                    sessionStorage(search);
                    debounceInput();
                  "
                ></v-text-field>
              </v-col>
              <v-col cols="auto">
                <router-link to="/societyadmin/staff/add" tag="button">
                  <v-btn class="primary">
                    <v-icon left> mdi-plus </v-icon>
                    Add Staff
                  </v-btn>
                </router-link>
              </v-col>
            </v-row>
          </v-card-title>
          <v-divider></v-divider>
          <v-data-table
            :headers="headers"
            :items="staffs"
            :search="search"
            :options.sync="options"
            :server-items-length="totalRecords"
            :loading="loading"
            :page.sync="page"
          >
              <template v-slot:item.picture_url="{ item }">
                <v-avatar
                  size="40"
                  v-if="item && item.picture_url != null"
                  class="mb-3 mt-3"
                >
                  <v-img
                    :src="API_BASE_URL + '/uploads/' + item.picture_url"
                    :alt="item.name"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-avatar>
                <v-avatar
                  v-else
                  color="primary  primary--text"
                  class="white--text mb-3 mt-3"
                  size="40"
                >
                  <span class="fontsize-11 white--text">
                    <span class="fontsize-11 white--text">{{
                      item.name ? item.name.charAt(0) : ""
                    }}</span></span
                  >
                </v-avatar>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn
                  icon
                  color="secondary"
                  name="edit_staff"
                  title="Edit staffs"
                  style="margin-left: -10px"
                  :to="'/societyadmin/staff/edit/' + item.id"
                >
                  <img src="@/components/icons/edit-02.svg" width="18" height="18" />
                </v-btn>
                <v-btn
                  icon
                  color="secondary"
                  name="delete_staff"
                  title="Delete Staff"
                  @click="confirmDelete(item.id)"
                >
                  <img src="@/components/icons/delete-01.svg" width="18" height="18" />
                </v-btn>
              </template>
            </v-data-table>
        </v-card>
      </v-flex>
      <v-dialog v-model="deleteDialog" width="500">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Confirm!!
          </v-card-title>
          <v-card-text class="mt-2">Are you sure want to delete? </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="deleteStaff(delete_id)">
              yes
            </v-btn>
            <v-btn color="primary" text @click="closeDialog"> No </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import { debounce } from "lodash";
import { mapMutations } from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      search: "",

      headers: [
        {
          text: `${this.$t("staff.headers.profile")}`,
          value: "picture_url",
          sortable: false,
          width: "20%",
        },
        {
          text: `${this.$t("staff.headers.name")}`,
          value: "name",
          width: "25%",
        },
        {
          text: `${this.$t("staff.headers.mobile_no")}`,
          value: "mobile_no",
          width: "25%",
        },
        {
          text: `${this.$t("staff.headers.designation")}`,
          value: "designation",
          width: "15%",
        },
        {
          text: `${this.$t("staff.headers.actions")}`,
          value: "actions",
          sortable: false,
          width: "15%",
        },
      ],
      user: {},
      addPermissionDialog: false,
      deleteDialog: false,
      staffs: [],
      delete_id: "",
      options: {
        sortBy: ["created_at"]
      },
      totalRecords: 0,
      loading: false,
      page: 1,
    };
  },
  watch: {
    options: {
      handler () {
        this.getStaffs();
      },
      deep: true,
    }
  },
  methods: {
    ...mapMutations("alert", ["setAlert"]),
    getStaffs() {
      this.loading = true;
      let page = this.options.page;
      let itemsPerPage = this.options.itemsPerPage;
      let sortBy = this.options.sortBy.length > 0 ? this.options.sortBy[0] : "";
      let sortDesc = this.options.sortDesc.length > 0 ? this.options.sortDesc[0] : "";
      let search = this.search ? this.search : "";

      let _self = this;
      _self.$axios
        .get("societyadmin/staffs?society_id=" + _self.user.id +
            "&page=" + page +
            "&perPage=" + itemsPerPage +
            "&sortBy=" + sortBy +
            "&sortDesc=" + sortDesc +
            "&search=" + search
        )
        .then((response) => {
          _self.loading = false;
          let data = response.data;

          if (data.status) {
            _self.staffs = data.staffs;
            _self.totalRecords = data.total;
            _self.page = data.page > data.lastPage ? 1 : data.page;
          } else {
            _self.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
            if (data.type == "invalid") {
              localStorage.removeItem("user");
              _self.$router.push({ path: "/societyadmin/login" });
            }
          }
        });
    },
    deleteStaff(staffId) {
      let _self = this;
      _self.$axios.delete("societyadmin/staffs/" + staffId).then((response) => {
        let data = response.data;

        if (data.status) {
          this.getStaffs();
          this.closeDialog();
          this.setAlert({
            showAlert: true,
            variant: "green accent-4",
            timeout: "2000",
            message: data.message,
          });
        } else {
          this.setAlert({
            showAlert: true,
            variant: "red accent-3",
            timeout: "2000",
            message: data.message,
          });
        }
      });
    },
    getFormattedDate(date) {
      return date ? moment(date).format("DD-MM-YYYY hh:mm A") : "N/A";
    },
    confirmDelete(id) {
      (this.deleteDialog = true), (this.delete_id = id);
    },
    sessionStorage(search) {
      if (search === null || search === "" || search === undefined) {
        sessionStorage.removeItem("staff_search");
      } else {
        const trimmedSearch = search.trim();
        this.search = trimmedSearch;
        sessionStorage.setItem("staff_search", trimmedSearch);
      }
    },
    closeDialog() {
      this.deleteDialog = false;
      this.addStaffDialog = false;
      this.staff = {};
      this.$validator.reset();
      this.serverSideErrors = [];
    },
    debounceInput: debounce(function(){
      this.getStaffs();
    }, 500),
  },
  mounted() {
    this.user = localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : {};
    // this.getStaffs();
    this.search = sessionStorage.getItem("staff_search");
  },
};
</script>